import { render } from "./MenoresListado.vue?vue&type=template&id=4f7c181c&ts=true"
import script from "./MenoresListado.vue?vue&type=script&lang=ts"
export * from "./MenoresListado.vue?vue&type=script&lang=ts"

import "./MenoresListado.vue?vue&type=style&index=0&id=4f7c181c&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__